import {
    default as getScriptInfoForLoadedScripts,
    ScriptInfo,
} from './utils/getScriptInfoForLoadedScripts';
import trace from './trace';

export default function onGlobalError(
    message: string,
    filename?: string,
    lineno?: number,
    colno?: number,
    error?: any
) {
    let callstack = error?.stack ? error.stack : '[empty onerror]';
    const diagnosticInfo = error?.diagnosticInfo ? error.diagnosticInfo : '';
    let corsInfo = '';

    // Detect CORS issues specifically so we can decorate them.
    // For now we're just prefixing the string.  Later when the analytics tables have been updated
    // we'll mark them specifically so we can track them down if needed.
    if (
        lineno === 0 &&
        /^Script error\.?$|^Javascript error: Script error\.? on line 0$/i.test(message)
    ) {
        message = 'CORS ISSUE: ' + message;

        // wrap this so if we have problems with getting additional info, we don't prevent the error reporting
        try {
            getScriptInfoForLoadedScripts().forEach((info: ScriptInfo) => {
                if (info.cors === null) {
                    corsInfo +=
                        'src: ' +
                        info.src +
                        ' cors: ' +
                        info.cors +
                        ' parent: ' +
                        info.parentNode +
                        ' baseUri: ' +
                        info.baseUri +
                        ' attributes: ' +
                        info.attributes +
                        '\n';
                }
            });
        } catch (e) {
            trace.error('problems searching for script tags after an error', e);
        }
    }

    const alreadyReported = error?.reported;
    if (!alreadyReported && !shouldSuppressError(message)) {
        // this will get picked up by any trace listeners for error that are registered globally
        trace.error({
            message: message,
            stack: callstack,
            name: error?.name,
            filename: filename,
            lineno: lineno,
            colno: colno,
            diagnosticInfo: diagnosticInfo || corsInfo,
            networkError: error?.networkError,
            httpStatus: error?.httpStatus,
        });
    }
}

function shouldSuppressError(message: string) {
    // This error means that ResizeObserver was not able to deliver all
    // observations within a single animation frame. It is benign
    return message === 'ResizeObserver loop limit exceeded';
}
